module.exports = __webpack_public_path__ + "static/media/announce2.d5aa3f34.jpg";